import BankIcon from "assets/icon/BankIcon";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import UserIcon from "assets/icon/UserIcon";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import { useNavigate } from "react-router-dom";

export default function Setting(){
    let navigate = useNavigate()

    return(
        <MainBodyCard>
            <PagesTitle title='Setting' />

            <div className="mt-4">

                <div className="border rounded-md p-4 bg-white">
                    <div className="pb-4">
                        <span className="text-xl font-semibold">Room Setting</span>
                    </div>
                    
                    <hr />

                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/room-type")}}>
                        <div className="flex items-center gap-4">
                            <BankIcon />
                            <span className="">Room Type</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    
                    <hr />
                    
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/room-setup")}}>
                        <div className="flex items-center gap-4">
                            <BankIcon />
                            <span className="">Room Setup</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>

                    <hr />
                </div>
                
                <div className={`border rounded-md bg-white p-4 mt-5 ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"}`}>
                    <div className="pb-4">
                        <span className="text-xl font-semibold">User Setting</span>
                    </div>

                    <hr />
                    
                    <button className="px-4 py-4  w-full text-left flex justify-between hover" onClick={() => {navigate("/setting/user")}}>
                        <div className="flex items-center gap-4">
                            <UserIcon className="fill-black" />
                            <span className="">User Setting</span>
                        </div>
                        <ChevronRightIcon className="fill-black w-6" />
                    </button>
                    
                    <hr />
                </div>
            </div>
        </MainBodyCard>
    )
}